var render = function render(_c,_vm){return (_vm.props.country)?_c('span',[(
      _vm.props.showFlag &&
        _vm.props.country.alpha2 &&
        typeof _vm.props.country.alpha2 === 'string'
    )?_c('span',{class:`flag-icon fi fi-${_vm.props.country.alpha2.toLowerCase()}`,attrs:{"title":_vm.props.country.name}}):_vm._e(),_vm._v(" "),(_vm.props.showIoc)?[_vm._v(" "+_vm._s(_vm.props.country.ioc))]:_vm._e(),_vm._t("append")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }